$W.on('load', function(){
	$('.js-page').addClass('is-active');
})

$(function(){

	$('.js-more-faq').on('click', function(e){
		e.preventDefault();
		$('.js-faq').show();
		$(this).hide();
	})

	$('.js-faq__name').on('click', function(){
		let $unit = $(this).closest('.js-faq');

		$unit.find('.js-faq__text').slideToggle();
		$(this).toggleClass('is-active');
	});

	//scroll to block
	let $scrollto = $('.js-scrollto');
	$scrollto.on('click', function(event) {
		event.preventDefault();
		$('html, body').animate({
			scrollTop: $($(this).attr('href')).offset().top - 70
		}, 500);
	});
})



	$('body').on('click', '.js-open-bowl', function(e){
		e.preventDefault();
		$(this).toggleClass('is-active')
		let container = $(this).closest('.js-bowl');

		container.find('.js-bowl__part').toggleClass('is-active');
	})
